import * as loadingState from '@blueberry/constants/loadingState';
import { HOME } from '@blueberry/constants/subjectType';

export const types = {
  FETCH_HOME: 'FETCH_HOME',
  FETCH_HOME_SUCCESS: 'FETCH_HOME_SUCCESS',
  FETCH_HOME_ERROR: 'FETCH_HOME_ERROR',
  RESET_HOME: 'RESET_HOME',
  CHANGE_PAGE: 'CHANGE_PAGE',
  CHANGE_LIMIT: 'CHANGE_LIMIT',
  SET_LATEST_POSTS: 'SET_LATEST_POSTS',
  SET_TREND_POSTS: 'SET_TREND_POSTS',
  SET_TOPIC_POSTS: 'SET_TOPIC_POSTS',
  FETCH_NEXT_PAGE: 'FETCH_NEXT_PAGE',
  FETCH_NEXT_PAGE_SUCCESS: 'FETCH_NEXT_PAGE_SUCCESS',
  FETCH_NEXT_PAGE_ERROR: 'FETCH_NEXT_PAGE_ERROR',
};

export const fetchHome = () => ({
  type: types.FETCH_HOME,
});

export const fetchHomeSuccess = ({
  totalCount,
  needLoadMore,
  pageName,
  pages,
  displayName,
}) => ({
  type: types.FETCH_HOME_SUCCESS,
  payload: {
    totalCount,
    needLoadMore,
    pageName,
    pages,
    displayName,
  },
});

export const fetchHomeError = errorCode => ({
  type: types.FETCH_HOME_ERROR,
  payload: {
    errorCode,
  },
});
export const changePage = page => ({
  type: types.CHANGE_PAGE,
  payload: {
    page,
  },
});

export const changeLimit = limit => ({
  type: types.CHANGE_LIMIT,
  payload: {
    limit,
  },
});

export const resetHome = () => ({
  type: types.RESET_HOME,
});

export const setLatestPosts = latestPosts => ({
  type: types.SET_LATEST_POSTS,
  payload: {
    latestPosts,
  },
});

export const setTrendPosts = trendPosts => ({
  type: types.SET_TREND_POSTS,
  payload: {
    trendPosts,
  },
});

export const setTopicPosts = topicPosts => ({
  type: types.SET_TOPIC_POSTS,
  payload: {
    topicPosts,
  },
});

export const fetchNextPage = () => ({
  type: types.FETCH_NEXT_PAGE,
});

export const fetchNextPageSuccess = () => ({
  type: types.FETCH_NEXT_PAGE_SUCCESS,
});

export const fetchNextPageError = errorCode => ({
  type: types.FETCH_NEXT_PAGE_ERROR,
  payload: {
    errorCode,
  },
});

export const INIT_STATE = {
  status: loadingState.EMPTY,
  latestPosts: [],
  trendPosts: [],
  topicPosts: [],
  page: 1,
  limit: 3,
  needLoadMore: true,
  totalCount: 0,
  pageName: HOME,
  pages: [],
  pageDisplayName: '',
};

const reducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case types.FETCH_HOME:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case types.FETCH_HOME_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        totalCount: action.payload.totalCount,
        needLoadMore: action.payload.needLoadMore,
        pageName: action.payload.pageName,
        pages: action.payload.pages,
        pageDisplayName: action.payload.displayName,
      };
    case types.FETCH_HOME_ERROR:
      return {
        ...state,
        status: loadingState.ERROR,
      };
    case types.RESET_HOME:
      return {
        ...state,
        ...INIT_STATE,
      };
    case types.CHANGE_PAGE:
      return {
        ...state,
        page: action.payload.page,
      };
    case types.CHANGE_LIMIT:
      return {
        ...state,
        limit: action.payload.limit,
      };
    case types.SET_LATEST_POSTS:
      return {
        ...state,
        latestPosts: action.payload.latestPosts,
      };
    case types.SET_TREND_POSTS:
      return {
        ...state,
        trendPosts: action.payload.trendPosts,
      };
    case types.SET_TOPIC_POSTS:
      return {
        ...state,
        topicPosts: action.payload.topicPosts,
      };
    case types.FETCH_NEXT_PAGE:
      return {
        ...state,
        status: loadingState.LOADING,
      };
    case types.FETCH_NEXT_PAGE_SUCCESS:
      return {
        ...state,
        status: loadingState.READY,
        needLoadMore: false,
      };
    case types.FETCH_NEXT_PAGE_ERROR:
      return {
        ...state,
        status: loadingState.ERROR,
      };
    default:
      return {
        ...state,
      };
  }
};

export default reducer;

export const getStatus = state => state.home.status;
export const getLatestPosts = state => state.home.latestPosts;
export const getTrendPosts = state => state.home.trendPosts;
export const getTopicPosts = state => state.home.topicPosts;
export const getPage = state => state.home.page;
export const getLimit = state => state.home.limit;
export const getNeedLoadMore = state => state.home.needLoadMore;
export const getPageName = state => state.home.pageName;
export const getRelatedPages = state => state.home.pages;
export const getPageDisplayName = state => state.home.pageDisplayName;



// WEBPACK FOOTER //
// ./app/redux/home.js